const organization = {
    require_membership: 'El usuario debe ser miembro de la organización para continuar.',
};
export default Object.freeze(organization);
